////////////////////////////////////////////////////////////////
//     所有跨平台等基础功能已由basement提供
//                该文件不再维护
//            为了兼容以及较小的侵入性
//           该文件保留对basement的引用
////////////////////////////////////////////////////////////////
export { default } from 'yofobasement/utils/BackHandler';



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/external/react-native-view/utils/BackHandler.js